import { type ReactElement } from "react";
import { Text, type TextProps } from "@citibox-panel/ui";
import { Row } from "./DemoScaffold";

const TEXT_VARIANTS: NonNullable<TextProps["variant"]>[] = [
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "subtitle1",
  "subtitle2",
  "body1",
  "body2",
  "button",
  "caption",
  "overline",
];

export function TextDemo(): ReactElement {
  return (
    <>
      <div style={{ display: "grid", gap: 8 }}>
        {TEXT_VARIANTS.map((variant) => (
          <Text key={variant} variant={variant}>
            {variant} — El veloz murciélago hindú
          </Text>
        ))}
      </div>
      <div style={{ height: 24 }} />
      <Text variant="subtitle2" component="h3" gutterBottom>
        Tonos de color
      </Text>
      <Row>
        <Text color="primary">primary — texto principal</Text>
        <Text color="secondary">secondary — texto secundario</Text>
        <Text color="disabled">disabled — texto deshabilitado</Text>
      </Row>
    </>
  );
}
